import React from 'react'

export default function useTitle ({title}) {
  document.title = title
}

